module.exports = __webpack_public_path__ + "img/predeter.2a5951b7.png";